import React, { useCallback, useEffect, useRef, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PropTypes from 'prop-types';
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Paper,
  Checkbox,
  IconButton,
  Fade,
  CircularProgress,
  Button,
  Popover,
  Skeleton,
  Backdrop,
  Tooltip,
  useMediaQuery,
  Stack,
  Autocomplete,
  MenuItem,
  ListItemText,
  TextField,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { ClearIcon } from '@mui/x-date-pickers';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import {
  Clear,
  Delete,
  Edit,
  DirectionsRun,
  Accessibility,
  EditOff,
  Email,
  MarkEmailUnread,
  ArrowCircleRight,
  CheckCircleOutline,
  DoDisturbAlt,
  EmailOutlined,
} from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { MoreVert } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import ConfirmDeleteModal from '../../components/modals/ConfirmDeleteModal';
import { API, graphqlOperation } from 'aws-amplify';

import { useLocation } from 'react-router-dom';
import DeleteParty from '../../components/modals/DeleteParty';
import DeleteSelectedParty from '../../components/modals/DeleteSelectedParty';
import { ThreeDot } from '../../components/DropDown/ThreeDot';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import DropDownForListing from '../../components/DropDown/DropDown';
import { ListSelection_fnForMasters } from '../../library/ListSelection';
import { FilterDropDown } from '../../components/DropDown/FilterDropDown';
import { MoneyFormat, MoneyFormatv3 } from '../../library/MoneyFormat';
import { useSelector } from 'react-redux';
import LinkList from '../../components/Buttons/linkList';
import { updateTitle } from '../../redux/reducers/titleSlice';
import moment from 'moment';
import SearchAutoComplete from '../../components/formElements/SearchAutoComplete';
import { useDebounce } from '../../hooks/useDebounce';
import { gstCategoryOptions, msmeOptions } from '../../utils/customerData';
import { defaultRowsPerPage, defaultRowsPerPageOptions, getDefaultSorting, handleFreeze } from '../../utils/common';
import SummaryDialog from '../../components/modals/SummaryDialog';
import ListingActive from '../../components/modals/ListingActive';
import MoneyRanger from '../../components/formElements/MoneyRanger';
import { useThemes } from '../../components/Theme/theme';
import { createPartyMaster, listPartymastersv2, listPartymastersv2Count, updateAccountMaster } from '../../graphql';
import { TableCell } from '../../components/Table/TableCell';
import { LedgerTransactionModalv2 } from '../LedgerTransaction';
import API_ENDPOINTS from '../../apiEndpoints';
import TableSearchButton from '../PrimeFigma/Components/TableSearchButton';
import { SendEmailModalWrapper, useSendEmailModal } from '../../features/Email';
import RollingSoon from '../../components/Ui/RollingSoon';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import { MoneyRangeWithCrDr, MoneyTextFieldRange } from '../../components';
import ExportModal from '../../features/Exports/components/ExportModal';
import { useExportModal } from '../../features/Exports/hooks/useExportModal';
import dayjs from 'dayjs';
import { useFetchOpeningBalanceDateQuery } from '../../redux/apis/openingbalacedate.api';

const headCell = [
  {
    id: 'PartyLegalName',
    numeric: false,
    disablePadding: true,
    label: 'Legal Name',
    width: '150px',
  },
  {
    id: 'PartyDisplayName',
    numeric: false,
    disablePadding: false,
    label: 'Ledger Name',
    width: '150px',
  },
  {
    id: 'balanceDue',
    numeric: true,
    disablePadding: false,
    label: 'Balance Due',
    width: '150px',
  },
  {
    id: 'GSTCategory',
    numeric: false,
    disablePadding: false,
    label: 'GST Category',
    minWidth: '70px',
  },
  {
    id: 'GSTIN',
    numeric: false,
    disablePadding: false,
    label: 'GSTIN',
    width: '130px',
  },
  {
    id: 'placeofsupply',
    numeric: false,
    disablePadding: false,
    label: 'Source of Supply',
    width: '120px',
  },
  {
    id: 'tdspercentage',
    numeric: true,
    disablePadding: false,
    label: 'TDS Rate',
    width: '80px',
  },
  {
    id: 'creditlimitamount',
    numeric: true,
    disablePadding: false,
    label: 'Credit Limit',
    width: '100px',
  },
  {
    id: 'creditperiodduration',
    numeric: true,
    disablePadding: false,
    label: 'Credit Period',
    width: '100px',
  },
  {
    id: 'ContactNumber',
    numeric: true,
    disablePadding: false,
    label: 'Phone Number',
    width: '100px',
  },
  {
    id: 'msmetype',
    numeric: false,
    disablePadding: false,
    label: 'MSME Type',
    width: '100px',
  },
  {
    id: 'comments',
    numeric: false,
    disablePadding: false,
    label: 'Remarks',
    width: '120px',
  },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    width: '100px',
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    onDelete,
    setEnableSearch,
    setShowActions,
    showActions,
    scroll,
  } = props;
  const [headCellSettings, setHeadCellSettings] = useState(headCell);
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const smalldevices = useMediaQuery('(max-width:480px)');

  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);

  async function getCompanyDetails() {
    try {
      let nonGstHeadCell = [];
      if (getCompany.relatedcompanydetailsnew[0].registrationtype == 1) {
        nonGstHeadCell = headCell.filter((ele, key) => {
          if (ele?.id !== 'GSTCategory' && ele?.id !== 'GSTIN' && ele?.id) {
            return ele;
          }
        });
        setHeadCellSettings(nonGstHeadCell);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  const { theme } = useThemes();

  useEffect(() => {
    getCompanyDetails();
  }, [getCompany]);

  useEffect(() => {
    const controlAndS = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        e.preventDefault();
        // showErrorSnackbar("Nothing to save");
      }
    };

    window.addEventListener('keydown', controlAndS);

    return () => {
      window.removeEventListener('keydown', controlAndS);
    };
  }, []);

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  return (
    <TableHead>
      <TableRow
        sx={{
          '.MuiTableCell-root': {
            backgroundColor: `${theme.palette.background.tablebg} !important`,
            fontSize: '14px',
            padding: '0px',
            '& .MuiCheckbox-root': {
              padding: '4px',
            },
            padding: '0px',
            '& .MuiCheckbox-root': {
              padding: '4px',
            },
            padding: '0px',
            '& .MuiCheckbox-root': {
              padding: '4px',
            },
          },
          backgroundColor: 'background.tablebg',
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '2px 10px',
            borderBottom: '0px',
          },
          height: '35px',
        }}
      >
        <TableCell
        // padding="checkbox"
        // sx={{
        //   ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
        //     padding: "5px",
        //   },
        // }}
        >
          <Checkbox
            sx={{ color: 'input.border' }}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
            size="small"
          />
        </TableCell>
        {headCellSettings.map((headCell) => (
          <TableCell
            id={headCell.id === 'Action' ? 'action' : ''}
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              minWidth: headCell.width,
              position: headCell.id === 'Action' ? 'sticky' : '',
              right: headCell.id === 'Action' ? 0 : '',
              // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",

              zIndex: headCell.id === 'Action' ? 1 : 0,
            }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={headCell.id !== 'Action' ? createSortHandler(headCell.id) : null}
              hideSortIcon={headCell.id === 'Action'}
              sx={{
                width: '100%',
                display: headCell.id === 'Action' ? 'flex' : undefined,
                justifyContent: headCell.id === 'Action' ? 'space-between' : undefined,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: headCell.id === 'Action' ? 'center' : 'space-between',
                  alignItems: 'center',
                  flexDirection: headCell.numeric ? 'row-reverse' : '',
                  // border: headCell.id === "Action" ? "1px solid black" : "",
                  borderRadius: headCell.id === 'Action' ? '3px' : '',
                  width: '100%',
                  backgroundColor: headCell.id === 'Action' ? 'white' : 'background.tablebg',
                  boxShadow: headCell.id === 'Action' && scroll ? '0px 4px 8px rgba(0, 0, 0, 0.6)' : '',
                  '&:active': {
                    transform: scroll ? 'scale(0.92)' : 'scale(1)',
                  },
                }}
                onClick={(e) => {
                  if (headCell.label === 'Actions') {
                    setShowActions((pre) => !pre);
                  }
                }}
              >
                <Box sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</Box>
                {headCell.id !== 'Action' ? (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {orderBy === headCell.id ? (
                      <Box
                        //  component="span"
                        sx={visuallyHidden}
                      >
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </Box>
                    ) : null}
                    {/* <SearchIcon
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setEnableSearch((prev) => !prev);
                      }}
                      sx={{ marginLeft: "10px" }}
                      fontSize="small"
                    /> */}
                  </Box>
                ) : headCell.id === 'Action' && scroll ? (
                  <ArrowCircleRight
                    sx={{
                      transition: 'transform 0.3s ease-in-out',
                      marginLeft: '10px',
                      transform: !showActions ? 'rotate(180deg)' : 'rotate(0deg)',
                      color: !showActions ? 'gray' : '#ee5b2b',
                    }}
                    fontSize="small"
                  />
                ) : null}
              </Box>
              {headCell.id === 'Action' ? (
                numSelected > 0 ? (
                  <Box>
                    <ThreeDot
                      onDelete={() => {
                        if (Freeze === 1) {
                          return handleFreeze();
                        }
                        onDelete(true);
                      }}
                    />
                  </Box>
                ) : null
              ) : (
                ''
              )}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
function AllSuppliers() {
  const { theme } = useThemes();
  const { defaultSortingColumn, defaultSortingOrder } = getDefaultSorting('party');
  const location = useLocation();
  const dispatch = useDispatch();
  dispatch(display());
  const navigate = useNavigate();
  const [order, setOrder] = useState(defaultSortingOrder);
  const [orderBy, setOrderBy] = useState(defaultSortingColumn);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [rows, setRows] = useState([]);
  const [deleteCustomerModal, setDeleteCustomerModal] = useState(false);
  const [partyData, setPartyData] = useState({});
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [firstMount, setfirstMount] = useState({ current: true });
  const [dataCount, setdataCount] = useState(0);
  const [activeValueModal, setActiveValueModal] = useState();
  const [showActions, setShowActions] = useState(true);
  const [meta, setMeta] = useState({ totalpartybalance: 0 });
  const supplierTableRef = useRef(null);

  useEffect(() => {
    if (firstMount.current) {
      setfirstMount({ current: false });
    }
  }, []);

  const defaultFilterColumns = {
    PartyLegalName: '',
    PartyDisplayName: location?.state?.search ?? '',
    balanceDue: '',
    AmountFrom: '',
    AmountTo: '',
    GSTCategory: '',
    GSTIN: '',
    placeofsupply: '',
    tdspercentage: '',
    creditlimitamount: '',
    creditlimitamountFrom: '',
    creditlimitamountTo: '',
    creditperiodduration: '',
    ContactNumber: '',
    msmetype: '',
    comments: '',
  };

  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
  const handleResetFilterColumns = (status) => (status === false ? setFilterColumns(defaultFilterColumns) : null);

  // State to manage the anchor element for the popover
  const [anchorEl, setAnchorEl] = useState(null);

  const [exportItem, setExportItem] = useState(null);

  const [exportModalOpen, setExportModalOpen] = useState(false); // State for the export modal
  const [ListSelection, setListSelection] = useState('All');
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  // Click handler for the main box to open the popover
  const handleClickBox = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  // Click handler to close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Check if the popover should be open based on anchorEl
  const open = Boolean(anchorEl);

  const { data: openingBalanceDate, isLoading } = useFetchOpeningBalanceDateQuery(
    {
      invoicetypecd: 'Sales',
      invoiceid: 0,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const [ledgerModalStartDate, setLedgerModalStartDate] = useState(0);
  const [ledgerModalEndDate, setLedgerModalEndDate] = useState(0);
  const userPrefrenceandReducer = useSelector((state) => state.userPrefrenceandReducer);
  useEffect(() => {
    const obDate = dayjs(openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate).unix();
    if (userPrefrenceandReducer?.financialYear) {
      const startDate = userPrefrenceandReducer?.financialYear?.startdate;
      if (obDate > startDate) {
        setLedgerModalStartDate(obDate);
      } else {
        setLedgerModalStartDate(userPrefrenceandReducer?.financialYear?.startdate);
      }
      setLedgerModalEndDate(userPrefrenceandReducer?.financialYear?.enddate);
    }
  }, [userPrefrenceandReducer, openingBalanceDate]);

  // Options to display in the popover, each with a label and onClick handler
  console.log(selected, 'selected');

  const options = [
    // {
    //   label: 'Import',
    //   icon: <CloudDownloadIcon sx={{ color: 'blue' }} />,
    //   onClick: () => navigate('/import-data'),
    //   link: '/import-data',
    // },
    {
      label: 'Export',
      icon: <CloudUploadIcon sx={{ color: '#ffa500' }} />,
      onClick: () => {
        ExportCustomerSupplier({
          partyOption: { partyType: 'SUPPLIER' },
          selectedArray: selected,
          startDate: ledgerModalStartDate,
          endDate: ledgerModalEndDate,
        });
      },
      // link: `/exports/supplier?startDate=${userPreferece?.financialYear?.startdate}&endDate=${userPreferece?.financialYear?.enddate}`,
      // rollingOutSoon: true,
    },
    {
      label: 'Send Selected Suppliers',
      icon: <MarkEmailUnread />,
      onClick: () => {
        handleBulkEmail();
      },
      link: '',
    },
  ];
  const [gstStatus, setGstStatus] = useState('');
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [filterValue, setFilterValue] = useState({
    minDue: undefined,
    maxDue: undefined,
  });
  console.log({ filterValue });
  const [accountID, setAccountID] = useState('');
  const [selectedParties, setSelectedParties] = useState([]);
  const { exportModalProps, ExportCustomerSupplier } = useExportModal();
  const { openModal, modalProps } = useSendEmailModal();

  const handleBulkEmail = () => {
    if (Freeze === 1) {
      return handleFreeze();
    }
    const idToFindDetails = rows
      .filter((row) => selected.includes(row.partyid))
      .map(
        ({
          partyid,
          email,
          partydisplayname,
          accountsid,
          partylegalname,
          enteredtimestamp,
          partytypecd,
          groupaccountid,
          comments,
          contactnumber,
          deliveryconsigneegstin,
          deliveryconsigneename,
          entity,
          gstcategory,
          is_active,
          msmetype,
          placeofsupply,
          sameaddressflag,
          tdspercentage,
          tdssection,
          udhyamregno,
          whatsappnumber,
        }) => ({
          PartyID: partyid,
          Email: email,
          PartyDisplayName: partydisplayname,
          enteredtimestamp,
          accountsid,
          partylegalname,
          partytypecd,
          groupaccountid,
          comments,
          contactnumber,
          deliveryconsigneegstin,
          deliveryconsigneename,
          entity,
          gstcategory,
          is_active,
          msmetype,
          placeofsupply,
          sameaddressflag,
          tdspercentage,
          tdssection,
          udhyamregno,
          whatsappnumber,
        })
      );
    if (idToFindDetails.length > 0) {
      setSelectedParties(idToFindDetails);
      openModal(
        'supplier',
        idToFindDetails.map((party) => ({
          id: Number(party.PartyID),
          recipientId: Number(party.PartyID),
          email: party.Email,
          name: party.PartyDisplayName,
        }))
      );
      // setTranscationDetails(idToFindDetails);
      // setTransactionModalOpen(true);
      // setMoreDetails({
      //   page: "Supplier",
      //   type: "multiple",
      //   refetch: () => {
      //     getPartyMasters(true, 0, rowsPerPage);
      //   },
      // });
    } else {
      showWarningSnackbar('No customers selected. Please select at least one customer to send the email.');
    }
  };

  const handleSelectAllClick = (event) => {
    const newSelected = rows.filter((e) => ListSelection_fnForMasters(e, ListSelection)).map((n) => n.partyid);
    if (event.target.checked && newSelected.length) {
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const isSmallDvce = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    if (backdropOpen) return;
    console.log(event, newPage);
    if (newPage > page) {
      console.log(newPage);
      if (rows.length !== dataCount)
        if (rows.length < rowsPerPage * (newPage + 1))
          getPartyMasters(false, rows.length, Math.abs(rowsPerPage * (newPage + 1) - rows.length));
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const [limit, setlimit] = useState(rowsPerPage);

  const [progress, setProgress] = useState(true);

  const updateCount = async () => {
    let searchMode = 1;
    let SearchArray = [{ PartyTypeCd: 'SUPPLIER' }];
    switch (ListSelection) {
      case 'Active':
        SearchArray = [...SearchArray, { Is_Active: 1 }];
        break;
      case 'InActive':
        SearchArray = [...SearchArray, { Is_Active: 0 }];
        break;
      default:
        break;
    }

    let resActiveCount = await API.graphql(
      graphqlOperation(listPartymastersv2Count, {
        columnname: orderBy,
        ordertype: order.toUpperCase(),
        searchmode: searchMode,
        searcharray: JSON.stringify(SearchArray),
      })
    );
    setdataCount(
      resActiveCount.data.listPartymastersv2Count[0]?.statuscode == null
        ? parseInt(resActiveCount.data.listPartymastersv2Count[0].partycount)
        : 0
    );
  };

  async function getPartyMasters(reset, from, to, filterColumn) {
    try {
      setProgress(true);
      if (rows.length / rowsPerPage == page + 1) {
        setlimit(to);
      } else if (rows.length / rowsPerPage < 1) {
        setlimit(rowsPerPage - rows.length);
      }
      setProgress(true);
      if (reset) {
        setRows([]);
        setPage(0);
      }
      let searchMode = 1;
      let SearchArray = [{ PartyTypeCd: 'SUPPLIER' }];
      filterColumn = filterColumn ? filterColumn : filterColumns;
      console.log(filterColumn, filterColumns);

      switch (ListSelection) {
        case 'Active':
          SearchArray = [...SearchArray, { Is_Active: 1 }];
          break;
        case 'InActive':
          SearchArray = [...SearchArray, { Is_Active: 0 }];
          break;
        default:
          break;
      }
      // Handle AmountFrom and AmountTo together to avoid duplicates
      const amountFrom = filterColumn.AmountFrom || '';
      const amountTo = filterColumn.AmountTo || '';

      if (amountFrom || amountTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerAmount = Number(amountFrom < amountTo ? amountFrom : amountTo);
        const higherAmount = Number(amountFrom < amountTo ? amountTo : amountFrom);

        // Add both values with correct order
        SearchArray = [...SearchArray, { AmountFrom: lowerAmount }, { AmountTo: higherAmount }];
      } else if (amountFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountFrom: amountFrom }];
      } else if (amountTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { AmountTo: amountTo }];
      }

      // Handle CreditLimitFrom and CreditLimitTo together to avoid duplicates
      const creditLimitFrom = filterColumn.creditlimitamountFrom || '';
      const creditLimitTo = filterColumn.creditlimitamountTo || '';

      if (creditLimitFrom || creditLimitTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerCreditLimit = Number(creditLimitFrom < creditLimitTo ? creditLimitFrom : creditLimitTo);
        const higherCreditLimit = Number(creditLimitFrom < creditLimitTo ? creditLimitTo : creditLimitFrom);

        // Add both values with correct order
        SearchArray = [...SearchArray, { creditlimitamountFrom: lowerCreditLimit }, { creditlimitamountTo: higherCreditLimit }];
      } else if (creditLimitFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { creditlimitamountFrom: creditLimitFrom }];
      } else if (creditLimitTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { creditlimitamountTo: creditLimitTo }];
      }

      Object.keys(filterColumn).map((key) => {
        if (filterColumn[key]?.toString()?.length > 0) {
          // Skip AmountFrom, AmountTo, creditlimitamountFrom, and creditlimitamountTo as they are handled above
          if (key !== 'AmountFrom' && key !== 'AmountTo' && key !== 'creditlimitamountFrom' && key !== 'creditlimitamountTo') {
            searchMode = 1;
            SearchArray = [...SearchArray, { [key]: filterColumn[key] }];
          }
        }
      });
      let resActive = API.graphql(
        graphqlOperation(listPartymastersv2, {
          rowfrom: from,
          limitno: to,
          columnname: orderBy,
          ordertype: order.toUpperCase(),
          searchmode: searchMode,
          searcharray: JSON.stringify(SearchArray),
        })
      );
      let resActiveCount = API.graphql(
        graphqlOperation(listPartymastersv2Count, {
          columnname: orderBy,
          ordertype: order.toUpperCase(),
          searchmode: searchMode,
          searcharray: JSON.stringify(SearchArray),
        })
      );
      if (reset) {
        setRows([]);
        setPage(0);
      }

      filterColumn = filterColumn ? filterColumn : filterColumns;

      Promise.all([resActive, resActiveCount])
        .then((response) => {
          let res = response[0];
          let dres = response[1];
          let arr = [...res?.data?.listPartymastersv2];
          let combinedArr = [];
          console.log(res, 'res');
          console.log(dres, 'dres');
          setdataCount(
            dres.data.listPartymastersv2Count[0]?.statuscode == null ? parseInt(dres.data.listPartymastersv2Count[0].partycount) : 0
          );
          setMeta({
            totalpartybalance: dres.data.listPartymastersv2Count[0]?.totalpartybalance || 0,
          });
          const { minbalancedue, maxbalancedue } = dres?.data.listPartymastersv2Count[0];

          if (maxbalancedue && minbalancedue) {
            console.log({ filterValue, maxbalancedue, minbalancedue });
            setFilterValue((prev) => {
              if (!prev?.maxDue && !prev?.minDue) {
                console.log(prev);
                console.log(prev);
                return {
                  minDue: dres?.data.listPartymastersv2Count[0].minbalancedue,
                  maxDue: dres?.data.listPartymastersv2Count[0]?.maxbalancedue,
                };
              } else {
                return prev;
              }
            });
          }
          combinedArr = [...arr.filter((elem) => elem.statuscode == null)];
          if (reset) {
            setRows((prev) => [...combinedArr]);
            setProgress(false);
          } else {
            setRows((prev) => [...prev, ...combinedArr]);
            setProgress(false);
          }
        })
        .finally(() => {
          setlimit(0);
          setProgress(false);
        });
    } catch (error) {
      console.log(error);
      setlimit(0);
      setProgress(false);
    }
  }

  const [SummaryData, setSummaryData] = useState({
    open: false,
    description: '',
    lists: [],
  });

  useEffect(() => {
    console.log(order, orderBy);
    setRows([]);
    setPage(0);
    getPartyMasters(true, 0, rowsPerPage);
    return () => {};
  }, [order, orderBy]);
  useEffect(() => {
    console.log(rowsPerPage, rows.length);
    if (firstMount.current === false) {
      if (rowsPerPage > rows.length) {
        console.log(rowsPerPage, rows.length);
        getPartyMasters(true, 0, rowsPerPage);
      } else {
        console.log(rowsPerPage, rows.length);
      }
    }
    return () => {};
  }, [rowsPerPage]);
  const filterBySearch = (event, category, value) => {
    setPage(0);
    let query = value ? value : event.target?.value;
    let name = category;
    const obj = { ...filterColumns };
    if (name === 'BalanceDue') {
      obj['AmountFrom'] = query[0];
      obj['AmountTo'] = query[1];
    } else if (name === 'CreditLimit') {
      obj['creditlimitamountFrom'] = query[0];
      obj['creditlimitamountTo'] = query[1];
    } else {
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          // obj[key] = "";
        }
      }
    }
    setFilterColumns(obj);
  };

  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);

  async function getCompanyDetails() {
    try {
      setGstStatus(getCompany.relatedcompanydetailsnew[0].registrationtype);
    } catch (error) {
      console.log('error', error);
    }
  }
  useEffect(() => {
    getCompanyDetails();
  }, [getCompany]);

  const markAsInActive = async (data, index) => {
    console.log(data, 'data');
    try {
      const LedgerData = {
        accountgroupid: data.groupaccountid,
        accountname: data.partylegalname,
        accounttypecd: 'BS',
        accountsid: data.accountsid,
        companybranchid: data.companybranchid,
        hsnsaccode: 0,
        is_active: data.is_active === 0 ? 1 : 0,
        accounttypeflag: data?.accounttypeflag ? data?.accounttypeflag : 0,
      };
      const masterData = {
        partyid: data.partyid,
        // companyid: getCompany?.companyid,
        companybranchid: data.companybranchid,
        expiredtimestamp: 0,
        partytypecd: data.partytypecd,
        sameaddressflag: data.sameaddressflag,
        comments: data.comments,
        partydisplayname: data.partydisplayname,
        partylegalname: data.partylegalname,
        groupaccountid: data.groupaccountid,
        gstcategory: data.gstcategory,
        placeofsupply: data.placeofsupply,
        entity: data.entity,
        email: data.email,
        contactnumber: data.contactnumber,
        whatsappnumber: data.whatsappnumber,
        accountsid: data.accountsid,
        is_active: data.is_active === 0 ? 1 : 0,
        lastupdatedby: data?.lastupdatedby,
        deliveryconsigneename: data.deliveryconsigneename,
        deliveryconsigneegstin: data.deliveryconsigneegstin,

        udhyamregno: data.udhyamregno,
        msmetype: data.msmetype,
        // tdspercentage: data.tdspercentage,
        financialyearid: getCompany?.relatedcompanydetailsnew[0]?.financialyearid,
        tdssection: data.tdssection,
        contactcountry: data.contactcountry,
        whatsappcountry: data.whatsappcountry,
        tdspercentage: data.tdspercentage ? Number(data.tdspercentage) : 0.0,
      };
      const resledger = await API.graphql(
        graphqlOperation(updateAccountMaster, {
          updateAccountMasterInput: LedgerData,
        })
      );
      if (resledger.data.updateAccountMaster.statuscode === 'Success') {
        const resMaster = await API.graphql(
          graphqlOperation(createPartyMaster, {
            createPartyMasterInput: masterData,
          })
        );
        showSuccessSnackbar(`${data.partylegalname} marked as ${data.is_active ? 'inactive' : 'active'} !`);
        let tempRow = rows.find((elem) => elem.partyid == data.partyid);
        let ind = rows.indexOf(tempRow);
        let tempRows = [...rows];
        tempRows[ind].is_active = data.is_active ? 0 : 1;
        // getPartyMasters(true, 0, rowsPerPage);
        setRows(tempRows);
        dispatch(dashboardApi.util.invalidateTags(['dashboard']));
      } else {
        showWarningSnackbar(resledger.data.updateAccountMaster.statusmessage);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [EnableSearch, setEnableSearch] = useState(location?.state?.search !== undefined);

  const search = (obj) => {
    console.log(obj);
    getPartyMasters(true, 0, rowsPerPage, obj);
  };
  const filterSearch = useCallback(
    useDebounce(
      (obj) => {
        search(obj);
      },
      900,
      false
    ),
    [ListSelection]
  );
  useEffect(() => {
    let searchFlag = false;
    if (firstMount.current === false) {
      if (
        Object.keys(filterColumns).map((key) => {
          if (filterColumns[key]?.toString()?.length > 0) {
            searchFlag = true;
          }
        })
      )
        console.log(searchFlag);
      // if (searchFlag) {
      console.log(filterColumns, filterValue);
      filterSearch(filterColumns);
      // } else {
      // filterSearch(filterColumns);
      // getPartyMasters(true, 0, rowsPerPage);
      // };
    }
    return () => {};
  }, [filterColumns, filterSearch, ListSelection]);

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    if (rows.length > 0 && !progress) {
      const width = supplierTableRef.current?.offsetWidth;
      const screenWidth = window.innerWidth;
      if (width < screenWidth) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    }
  }, [rows, progress]);

  const getLabelForValue = (value, options) => {
    console.log(value, 'value');
    console.log(options, 'options');
    const option = options.find((option) => option.id === value);
    return option ? option.text : 'Unknown';
  };

  const getMsmeLabelForValue = (value) => {
    const option = msmeOptions.find((option) => option.id === value);
    return option ? option.label : value;
  };
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const [rolling, setRolling] = useState(false);

  return (
    <Box className="PageHeight noTableCellBorder">
      <ConfirmDeleteModal open={deleteModalStatus} setOpen={setDeleteModalStatus} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: { xs: '-10px', sm: '0px' },
        }}
      >
        <span style={{ fontWeight: 'bold', fontSize: 'clamp(10px, 2vw, 16px)' }}>
          TOTAL BALANCE: {meta.totalpartybalance ? MoneyFormatv3(meta.totalpartybalance) : '₹ 0.00'}
        </span>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTopRightRadius: '12px',
          borderTopLeftRadius: '12px',
          padding: '8px 10px',
          backgroundColor: 'primary.main',
          // marginBottom:'20px'
        }}
      >
        <LinkList list="All Suppliers" link="/addsupplier" add="Add Supplier" />

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'supplierSearch'}
            onClick={handleResetFilterColumns}
          />

          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex',
              },
            }}
          >
            <Typography
              sx={{
                fontSize: '13px',
                display: 'flex',
                alignItems: 'center',
                color: 'white',
                whiteSpace: 'nowrap',
              }}
            >
              Total : {dataCount} Item{dataCount !== 1 && 's'}
              {selected.length != 0 ? ` ( Selected: ${selected.length}/${dataCount})` : ''}
            </Typography>
            <DropDownForListing
              name={'ser'}
              list={[
                { label: 'All', value: 'All' },
                { label: 'Active', value: 'Active' },
                { label: 'In-Active', value: 'InActive' },
              ]}
              value={ListSelection}
              onChange={(e) => {
                setListSelection(e.target.value);
                setPage(0);
              }}
            />

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid transparent',
                borderRadius: '5px',
                p: 1,
                cursor: 'pointer',
                '&:hover': {
                  borderColor: '#ccc',
                  backgroundColor: theme.palette.input.border || '#f5f5f5',
                },
              }}
              onClick={handleClickBox} // Toggle the popover on box click
            >
              <MoreVert sx={{ fontSize: '20px', color: '#fff' }} />

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Box sx={{ p: 1 }}>
                  {options.map((option, index) =>
                    option.rollingOutSoon ? (
                      <Typography
                        key={index}
                        onClick={() => {
                          handleClose();
                        }}
                        sx={{
                          padding: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          // '&:hover': {
                          //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                          // },
                        }}
                      >
                        <Tooltip
                          title={<RollingSoon />}
                          placement="right"
                          PopperProps={{
                            sx: {
                              '& .MuiTooltip-tooltip': {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                                padding: 0,
                              },
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {option.icon}
                            <span style={{ marginLeft: '8px', opacity: 0.5 }}>{option.label}</span>
                          </Box>
                        </Tooltip>
                      </Typography>
                    ) : (
                      <Link style={{ textDecoration: 'none', color: 'inherit' }} to={option.link} state={{ fromLink: '/customerList' }}>
                        <Typography
                          key={index}
                          onClick={() => {
                            handleClose();
                            option.onClick();
                          }}
                          sx={{
                            cursor: 'pointer',
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            // '&:hover': {
                            //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                            // },
                          }}
                        >
                          {option.icon}
                          <span style={{ marginLeft: '8px' }}>{option.label}</span>
                        </Typography>
                      </Link>
                    )
                  )}
                </Box>
              </Popover>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          // boxShadow: "inset 0 0 8px #d7d7d73b",
          boxShadow: 'rgb(33 35 38 / 10%) 0px 10px 10px -10px',
          borderBottomRightRadius: '12px',
          borderBottomLeftRadius: '12px',
          // backgroundColor: "#fff",
          // backgroundColor: theme.palette.bodyGray.secondary,
          // borderRadius:'12px',
          padding: {
            // xs: "8px 12px",
          },
          '.css-1mxz8qt-MuiPaper-root': {
            boxShadow: 'none',
          },
          '.MuiTableCell-root': {
            padding: '1px 10px',
            fontSize: '13px',
          },
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            // padding: "5px 10px",
            borderBottom: '0px',
          },
        }}
      >
        {rows.length <= 0 && isSmallDvce ? (
          <Typography
            sx={{
              width: '100%',
              height: '70vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            No data Found
          </Typography>
        ) : (
          <Box
            sx={{
              width: '100%',
              overflow: 'hidden',
              boxShadow: 'none',
              // backgroundColor: theme.palette.bodyGray.secondary,
              // backgroundColor:"orange",
              borderBottomLeftRadius: '6px',
              borderBottomRightRadius: '6px',
            }}
          >
            <TableContainer
              className="custom-scrollbar"
              sx={{
                height: {
                  sm: 'calc( 100vh - 230px )',
                  xs: 'calc( 100vh - 180px )',
                },
              }}
            >
              <Table
                stickyHeader
                aria-label="sticky table"
                sx={{ minWidth: 1200 }}
                aria-labelledby="tableTitle"
                size={dense ? 'small' : 'medium'}
              >
                <EnhancedTableHead
                  EnableSearch={EnableSearch}
                  setEnableSearch={setEnableSearch}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={dataCount}
                  onDelete={() => setDeleteSelectedModal(true)}
                  setShowActions={setShowActions}
                  showActions={showActions}
                  scroll={scroll}
                />
                <TableBody ref={supplierTableRef}>
                  <TableRow
                    sx={{
                      '.MuiTableCell-root': {
                        backgroundColor: 'transparent ',
                        padding: '8px 15px',
                      },
                      '.css-wrnu0i-MuiInputBase-root': {
                        fontSize: '13px',
                      },
                      '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                        padding: '2px 4px',
                      },
                      '.css-1gqfvv-MuiPaper-root': {
                        boxShadow: 'none',
                        borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                        borderRadius: '0px',
                      },
                      // visibility: !EnableSearch ? "collapse" : "visible",
                      display: !EnableSearch ? 'none' : 'content',
                    }}
                  >
                    <TableCell></TableCell>
                    <TableCell>
                      <Paper
                        id="supplierSearch"
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="PartyLegalName"
                          value={filterColumns.PartyLegalName}
                          onChange={(e) => filterBySearch(e, 'PartyLegalName')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.PartyLegalName !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  PartyLegalName: '',
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                        {/* <FilterDropDown setSortType={setSortType} /> */}
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="PartyDisplayName"
                          value={filterColumns.PartyDisplayName}
                          onChange={(e) => filterBySearch(e, 'PartyDisplayName')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.PartyDisplayName !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  PartyDisplayName: '',
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                        {/* <FilterDropDown setSortType={setSortType} /> */}
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          width: '100%',
                        }}
                      >
                        <Stack direction={'row'} height={'32px'} gap="5px">
                          <MoneyRangeWithCrDr
                            value={[filterColumns.AmountFrom, filterColumns.AmountTo]}
                            enforceOrder={false}
                            crDrPosition="right"
                            swapLogic={false}
                            showCrDr={true}
                            showNegativeValues={false}
                            defaultMinCrDr="CR"
                            defaultMaxCrDr="CR"
                            onChange={(e) => {
                              filterBySearch(e, 'BalanceDue', e);
                            }}
                          />
                          <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.AmountFrom !== '' || filterColumns.AmountTo !== '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    AmountFrom: '',
                                    AmountTo: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Stack>
                      </Paper>
                    </TableCell>

                    {gstStatus !== 1 && (
                      <>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <SearchAutoComplete
                              placeholder="Search"
                              name="GSTCategory"
                              value={filterColumns.GSTCategory}
                              onChange={filterBySearch}
                              state={filterColumns}
                            />
                            <IconButton type="button" sx={{ padding: '0px' }}>
                              {filterColumns.GSTCategory !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      GSTCategory: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                            {/* <FilterDropDown setSortType={setSortType} /> */}
                          </Paper>
                        </TableCell>
                        <TableCell>
                          <Paper
                            sx={{
                              p: '2px 4px',
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <InputBase
                              name="GSTIN"
                              value={filterColumns.GSTIN}
                              onChange={(e) => filterBySearch(e, 'GSTIN')}
                              sx={{ flex: 1 }}
                              placeholder="Search"
                              autoComplete="off"
                            />
                            <IconButton type="button" sx={{ padding: '0px' }}>
                              {filterColumns.GSTIN !== '' ? (
                                <Clear
                                  fontSize="small"
                                  onClick={() => {
                                    setFilterColumns((prev) => ({
                                      ...prev,
                                      GSTIN: '',
                                    }));
                                  }}
                                />
                              ) : (
                                <SearchIcon fontSize="small" />
                              )}
                            </IconButton>
                            {/* <FilterDropDown setSortType={setSortType} /> */}
                          </Paper>
                        </TableCell>
                      </>
                    )}

                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="placeofsupply"
                          value={filterColumns.placeofsupply}
                          onChange={(e) => filterBySearch(e, 'placeofsupply')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.placeofsupply !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  placeofsupply: '',
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>

                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="tdspercentage"
                          type="number"
                          value={filterColumns.tdspercentage}
                          onChange={(e) => filterBySearch(e, 'tdspercentage')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.tdspercentage !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  tdspercentage: '',
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>

                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          width: '100%',
                        }}
                      >
                        <Stack direction={'row'} height={'32px'} gap="5px">
                          <MoneyTextFieldRange
                            value={[filterColumns.creditlimitamountFrom, filterColumns.creditlimitamountTo]}
                            onChange={(e) => {
                              filterBySearch(e, 'CreditLimit', e);
                            }}
                          />
                          <IconButton type="button" sx={{ p: '0px' }}>
                            {filterColumns.creditlimitamountFrom !== '' || filterColumns.creditlimitamountTo !== '' ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    creditlimitamountFrom: '',
                                    creditlimitamountTo: '',
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Stack>
                      </Paper>
                    </TableCell>

                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="creditperiodduration"
                          type="number"
                          value={filterColumns.creditperiodduration}
                          onChange={(e) => filterBySearch(e, 'creditperiodduration')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.creditperiodduration !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  creditperiodduration: '',
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>

                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="ContactNumber"
                          type="number"
                          value={filterColumns.ContactNumber}
                          onChange={(e) => filterBySearch(e, 'ContactNumber')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.ContactNumber !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  ContactNumber: '',
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>

                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          border: 'none',
                        }}
                      >
                        <Autocomplete
                          id={''}
                          disableClearable
                          options={msmeOptions.map((option) => option.label)}
                          isOptionEqualToValue={(option, value) => option == value}
                          clearIcon={filterColumns.msmetype !== '' ? <ClearIcon style={{ fontSize: '20px' }} /> : null}
                          name="msmetype"
                          value={filterColumns.msmetype}
                          onChange={(e, newvalue) => filterBySearch({ target: { value: newvalue } }, 'msmetype')}
                          size="small"
                          sx={{ height: '32px' }}
                          renderOption={(props, option) => (
                            <>
                              <MenuItem {...props} key={option} value={option}>
                                <ListItemText primary={option} />
                              </MenuItem>
                            </>
                          )}
                          renderInput={(params) => (
                            <TextField
                              sx={{
                                minWidth: '100px',
                                border: 'none',
                                '& .MuiInput-underline:before': {
                                  borderBottom: 'none',
                                },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                                  borderBottom: 'none',
                                },
                                '& .MuiInput-underline:after': {
                                  borderBottom: 'none',
                                },
                                '& fieldset': { border: 'none' },
                              }}
                              placeholder={'Search'}
                              variant="standard"
                              InputLabelProps={{
                                shrink: true,
                                style: { color: 'black' },
                              }}
                              {...params}
                            />
                          )}
                        />
                        <IconButton type="button" sx={{ p: '0px' }}>
                          {filterColumns.msmetype !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  msmetype: '',
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>

                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="comments"
                          value={filterColumns.comments}
                          onChange={(e) => filterBySearch(e, 'comments')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.comments !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  comments: '',
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>

                    <TableCell className="actionBackGround" sx={{ backgroundColor: 'transparent !important' }}></TableCell>
                  </TableRow>
                  {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                            rows.slice().sort(getComparator(order, orderBy)) */}
                  {rows.length > 0 ? (
                    rows
                      .filter((e) => ListSelection_fnForMasters(e, ListSelection))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.partyid);
                        console.log(selected);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        // row?.relatedPartyGstDetails?.map((item) => {
                        //   row.GSTIN = item.GSTIN;
                        // });
                        const labelToDisplay = getLabelForValue(row.gstcategory, gstCategoryOptions);
                        return (
                          <TableRow
                            hover
                            className={!row.is_active ? 'rowInactiveMuted' : ''}
                            onClick={(event) => {
                              // handleClick(event, row.phNumber)

                              // if (
                              //   event.target === event.currentTarget ||
                              //   event.target.tagName === "TD"
                              // ) {
                              dispatch(updateTitle(row.partylegalname));
                              navigate('/viewsupplier', {
                                state: { id: row.partyid, view: true },
                              });
                              // }
                            }}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            selected={isItemSelected}
                            tabIndex={-1}
                            key={index}
                            style={{ cursor: 'pointer' }}
                            sx={{
                              '.MuiTableCell-root': {
                                backgroundColor: 'transparent ',
                                borderBottom: 'none',
                              },
                            }}
                          >
                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              padding="checkbox"
                              sx={{
                                '.css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root': {
                                  padding: '5px',
                                },
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                              }}
                            >
                              <Checkbox
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleClick(event, row.partyid);
                                }}
                                color="primary"
                                checked={isItemSelected}
                                inputProps={{
                                  'aria-labelledby': labelId,
                                }}
                                size="small"
                              />
                            </TableCell>
                            {/* <TableCell
                              // component="th"
                              title={row.is_active === 1 ? "" : "InActive"}
                              id={labelId}
                              scope="row"
                              sx={{
                                cursor: "pointer",
                                color: theme.palette.text.Link,
                                textDecoration: "underline",
                              }}
                              onClick={(event) => {
                                event.stopPropagation();
                                dispatch(updateTitle(row.partylegalname));
                                // navigate("/viewsupplier", {
                                //   state: { id: row.PartyID, view: true },
                                // });
                              }}
                            >
                              <a
                                id="myLink"
                                href={`/viewsupplier?id=${row.partyid}&view=true&title=${row?.partylegalname}`}
                                target="_blank"
                              >
                                {row.partylegalname}
                              </a>
                            </TableCell> */}

                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              align="left"
                              sx={{
                                maxWidth: '150px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                              }}
                            >
                              <Tooltip title={row.partylegalname} placement="right">
                                <span
                                  style={{
                                    display: 'block',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {row.partylegalname}
                                </span>
                              </Tooltip>
                            </TableCell>
                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              align="left"
                              sx={{
                                maxWidth: '150px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                              }}
                            >
                              <Tooltip title={row.partydisplayname} placement="right">
                                <span
                                  style={{
                                    display: 'block',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {row.partydisplayname}
                                </span>
                              </Tooltip>
                            </TableCell>
                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              sx={{
                                background: 'transparent !important',
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                              }}
                              align="right"
                            >
                              <a
                                underline="hover"
                                style={{
                                  color: row.accountbalance < 0 ? 'red' : theme.palette.text.Link,
                                  cursor: 'pointer',
                                }}
                                href={`/LedgerTransactions/${row?.accountsid}`}
                                onClick={(e) => {
                                  console.log(row);
                                  e.stopPropagation();
                                  e.preventDefault();
                                  dispatch(updateTitle(row.invoicenumber));
                                  if (row?.accountsid !== '') {
                                    // localStorage.removeItem('IsLedgerViewModalOpen')
                                    // setBackdropOpen(true);
                                    // setAccountName(row?.PartyDisplayName);
                                    setAccountID(row?.accountsid);
                                    // getModalData(row?.AccountsID);
                                  }
                                }}
                              >
                                {' '}
                                {row.accountbalance == 0 || isNaN(row.accountbalance) || !row?.accountbalance ? (
                                  '0.00'
                                ) : (
                                  <>{MoneyFormatv3(Number(Math.abs(row.accountbalance)).toFixed(2), 'en-IN')}</>
                                )}
                              </a>
                              <span
                                style={{
                                  visibility: !row.accountbalance ? 'hidden' : 'visible',
                                  color: row.accountbalance < 0 ? 'red' : theme.palette.text.Link,
                                }}
                              >
                                {row.accountbalance > 0 ? ' Cr' : ' Dr'}
                              </span>
                            </TableCell>

                            {gstStatus !== 1 && (
                              <>
                                <TableCell
                                  title={row.is_active === 1 ? '' : 'Inactive'}
                                  align="left"
                                  sx={{
                                    padding: '0px',
                                    '& .MuiCheckbox-root': {
                                      padding: '4px',
                                    },
                                  }}
                                >
                                  {labelToDisplay}
                                </TableCell>
                                <TableCell
                                  title={row.is_active === 1 ? '' : 'Inactive'}
                                  align="left"
                                  sx={{
                                    padding: '0px',
                                    '& .MuiCheckbox-root': {
                                      padding: '4px',
                                    },
                                  }}
                                >
                                  {row.gstin}
                                </TableCell>
                              </>
                            )}

                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              align="left"
                              sx={{
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                              }}
                            >
                              {row.placeofsupply}
                            </TableCell>

                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              align="right"
                              sx={{
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                              }}
                            >
                              {row.tdspercentage ? `${row.tdspercentage}%` : ''}
                            </TableCell>

                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              align="right"
                              sx={{
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                              }}
                            >
                              {row.creditlimitamount ? MoneyFormatv3(Number(row.creditlimitamount).toFixed(2), 'en-IN') : ''}
                            </TableCell>

                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              align="right"
                              sx={{
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                              }}
                            >
                              {row.creditperiodduration
                                ? `${row.creditperiodduration} ${row.creditperiodduration === 1 ? 'day' : 'days'}`
                                : ''}
                            </TableCell>

                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              align="right"
                              sx={{
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {row.contactnumber === 0 ? '' : row.contactnumber}
                            </TableCell>

                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              align="left"
                              sx={{
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                              }}
                            >
                              {getMsmeLabelForValue(row.msmetype)}
                            </TableCell>

                            <TableCell
                              title={row.is_active === 1 ? '' : 'Inactive'}
                              align="left"
                              sx={{
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                                maxWidth: '120px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              <Tooltip title={row.comments} placement="right">
                                <span
                                  style={{
                                    display: 'block',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {row.comments}
                                </span>
                              </Tooltip>
                            </TableCell>
                            <TableCell
                              // sx={{ background: "transparent !important" }}
                              className="actionBackGround"
                              align="left"
                              sx={{
                                padding: '0px',
                                '& .MuiCheckbox-root': {
                                  padding: '4px',
                                },
                                position: !showActions ? 'relative' : 'sticky',
                              }}
                            >
                              <Box className="actionCellStyle">
                                {/* <IconButton
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  backgroundColor: "#c1f2f5a1",
                                }}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  navigate("/viewsupplier", {
                                    state: { id: row.PartyID, view: true },
                                  });
                                }}
                              >
                                <VisibilityIcon
                                  sx={{
                                    fontSize: "15px",
                                    color: "primary.main",
                                  }}
                                />
                              </IconButton>
                              <IconButton
                                onClick={(event) => {
                                  event.stopPropagation();
                                  setDeleteCustomerModal(true);
                                  setPartyData({
                                    id: row.PartyID,
                                    ind: index,
                                  });
                                }}
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  backgroundColor: "#fbc7c78c",
                                }}
                              >
                                <DeleteIcon
                                  sx={{ fontSize: "15px", color: "#eb6a6a" }}
                                />
                              </IconButton>
                              <IconButton
                                aria-label="delete"
                                sx={{
                                  margin: "0px 2px",
                                  padding: "5px",
                                  backgroundColor: "#b1d1f97d",
                                }}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  navigate("/editsupplier", {
                                    state: {
                                      id: row.PartyID,
                                      timeStamp: row.EnteredTimeStamp,
                                    },
                                  });
                                }}
                              >
                                <EditIcon
                                  sx={{ fontSize: "15px", color: "#6096d9" }}
                                />
                              </IconButton> */}
                                {/* <ThreeDot
                                onMarkIA={
                                  row.ExpiredTimeStamp !== 0
                                    ? null
                                    : row.Is_Active
                                      ? (event) => {
                                        event.stopPropagation();
                                        markAsInActive(row, index);
                                        markAsInActive(row, index);
                                      }
                                      : null
                                }
                                onMarkA={
                                  row.ExpiredTimeStamp !== 0
                                    ? null
                                    : row.Is_Active
                                      ? null
                                      : (event) => {
                                        event.stopPropagation();
                                        markAsInActive(row, index);
                                        markAsInActive(row, index);
                                      }
                                }
                                onView={(event) => {
                                  event.stopPropagation();
                                  dispatch(updateTitle(row.PartyLegalName));
                                  navigate("/viewsupplier", {
                                    state: { id: row.PartyID, view: true },
                                  });
                                }}
                                onDelete={
                                  row.ExpiredTimeStamp !== 0
                                    ? null
                                    : (event) => {
                                      event.stopPropagation();
                                      setDeleteCustomerModal(true);
                                      setPartyData({
                                        id: row.PartyID,
                                        ind: index,
                                      });
                                    }
                                }
                                onEdit={
                                  row.ExpiredTimeStamp !== 0
                                    ? null
                                    : row.Is_Active
                                      ? (event) => {
                                        event.stopPropagation();
                                        dispatch(
                                          updateTitle(row.PartyLegalName)
                                        );
                                        navigate("/editsupplier", {
                                          state: {
                                            id: row.PartyID,
                                            timeStamp: row.EnteredTimeStamp,
                                          },
                                        });
                                      }
                                      : null
                                }
                              /> */}

                                <IconButton
                                  onClick={(e) => {
                                    if (row.is_active !== 1) return;
                                    e.stopPropagation();
                                    e.preventDefault();
                                    openModal('supplier', [
                                      {
                                        id: Number(row?.partyid),
                                        recipientId: Number(row?.partyid),
                                        email: row?.email,
                                        name: row?.partydisplayname,
                                      },
                                    ]);
                                    setSelected([]);
                                  }}
                                  aria-label="share"
                                  title={row.is_active === 1 ? 'Email' : 'Cannot send email'}
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: row.is_active === 1 ? '#0494c2' : '#e4e8ebff',
                                    cursor: row.is_active === 1 ? 'pointer' : 'not-allowed',
                                    pointerEvents: row.is_active === 1 ? 'auto' : 'none',
                                    border: 'solid 1px black',
                                  }}
                                >
                                  {row.is_active === 1 ? (
                                    <Email sx={{ fontSize: '10px', color: '#fff' }} />
                                  ) : (
                                    <EmailOutlined sx={{ fontSize: '10px', color: '#919191' }} />
                                  )}
                                </IconButton>

                                <Tooltip
                                  title={row.is_active == 1 ? 'Mark as Inactive' : 'Mark as Active'}
                                  placement="left"
                                  disableInteractive
                                  arrow
                                >
                                  <IconButton
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      if (Freeze === 1) {
                                        return handleFreeze();
                                      } else {
                                        setActiveValueModal(row);
                                      }
                                    }}
                                    aria-label="delete"
                                    sx={{
                                      margin: '0px 2px',
                                      padding: '5px',
                                      backgroundColor: 'white',
                                      border: 'solid 1px black',
                                      // backgroundColor: "#c1f2f5a1",
                                    }}
                                  >
                                    {row.is_active == 1 ? (
                                      <CheckCircleOutline
                                        sx={{
                                          fontSize: '10px',
                                          color: 'green',
                                          // color: "#057d86",
                                        }}
                                      />
                                    ) : (
                                      <DoDisturbAlt
                                        sx={{
                                          fontSize: '10px',
                                          color: 'red',
                                          // color: "#057d86",
                                        }}
                                      />
                                    )}
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={'Delete'} placement="top" disableInteractive arrow>
                                  <IconButton
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      if (Freeze == 1) {
                                        return handleFreeze();
                                      }
                                      setDeleteCustomerModal(true);
                                      setPartyData({
                                        id: row.partyid,
                                        accountsid: row.accountsid,
                                      });
                                    }}
                                    aria-label="delete"
                                    sx={{
                                      margin: '0px 2px',
                                      padding: '5px',
                                      // backgroundColor: "#fbc7c7",
                                      backgroundColor: 'white',
                                      border: 'solid 1px black',
                                    }}
                                  >
                                    <Delete
                                      sx={{
                                        fontSize: '10px',
                                        color: '#eb6a6a',
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={row.is_active == 1 ? 'Edit' : 'Cannot Edit'} placement="right" disableInteractive arrow>
                                  <IconButton
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      if (row.is_active == 1) {
                                        if (Freeze == 1) {
                                          return handleFreeze();
                                        }
                                        dispatch(updateTitle(row.partylegalname));
                                        navigate('/editsupplier', {
                                          state: {
                                            id: row.partyid,
                                            timeStamp: row.enteredtimestamp,
                                          },
                                        });
                                      }
                                    }}
                                    aria-label="delete"
                                    sx={{
                                      margin: '0px 2px',
                                      padding: '5px',
                                      backgroundColor: row.is_active == 1 ? '#D0EFFF' : '#9191912e',
                                      border: 'solid 1px black',
                                    }}
                                  >
                                    {row.is_active == 1 ? (
                                      <Edit
                                        sx={{
                                          fontSize: '10px',
                                          color: '#6096d9',
                                        }}
                                      />
                                    ) : (
                                      <EditOff
                                        sx={{
                                          fontSize: '10px',
                                          color: '#6096d9',
                                        }}
                                      />
                                    )}
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </TableCell>
                          </TableRow>
                        );
                      })
                  ) : progress == false ? (
                    <TableRow>
                      <TableCell align="center" height={400} colSpan={14} sx={{ border: 'none' }}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}
                  {progress == true &&
                    limit > 0 &&
                    Array.from({ length: limit }, (_, index) => (
                      <TableRow key={index}>
                        <TableCell colSpan={14}>
                          <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            {dataCount > 0 && (
              <TablePagination
                // rowsPerPageOptions={[5, 10, 25,{ label: 'All', value: -1 }]}
                rowsPerPageOptions={defaultRowsPerPageOptions}
                component="div"
                count={dataCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Box>
        )}
      </Box>

      <DeleteParty
        type={'Supplier'}
        open={deleteCustomerModal}
        setOpen={setDeleteCustomerModal}
        partyData={partyData}
        rows={rows}
        setRows={setRows}
        getPartyMasters={getPartyMasters}
        onDelete={updateCount}
      />
      <DeleteSelectedParty
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        partysData={selected}
        setSelected={setSelected}
        rows={rows}
        setRows={setRows}
        getPartyMasters={getPartyMasters}
        setSummaryData={setSummaryData}
        onDelete={updateCount}
      />
      {/* <ExportData
        setOpen={setExportModalOpen}
        open={exportModalOpen}
        item={exportItem}
      /> */}
      <SummaryDialog data={SummaryData} />

      {activeValueModal && (
        <ListingActive
          text={'supplier'}
          open={activeValueModal}
          editData={{ serialisactive: activeValueModal?.is_active }}
          setOpen={setActiveValueModal}
          action={() => {
            markAsInActive(activeValueModal);
          }}
        />
      )}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} in={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {accountID && <LedgerTransactionModalv2 open={accountID} accountId={accountID} includingOpeningBalance onClose={() => setAccountID('')} />}

      <SendEmailModalWrapper {...modalProps} />
      <ExportModal {...exportModalProps} />
    </Box>
  );
}

export default AllSuppliers;
